import type { TLure } from '../types'

export const filterLuresByInsectId = (lures: TLure[], insectId: number | null): TLure[] => {
  if (!insectId) return lures

  return lures.filter((lure) => lure.insectIds.includes(insectId))
}
